import Phaser from 'phaser'

export default class GameOver extends Phaser.Scene {
    private caller!: string

    constructor() {
        super('gameOver');
    }

    // Scene initialisieren, die GameOver aufgerufen hat
    init(data) {
        this.caller = data.caller
    }

    create() {
        this.scene.stop('hints')
        this.scene.stop('equipment')
        var flag = sessionStorage.getItem('flag')
        if (flag == "true") {
            const caught = this.sound.add('caught', { volume: 0.1 })
            caught.play()
        }

        // SCORE erhöhen
        let currentScore: number = parseInt(sessionStorage.getItem('score') || '0', 10);
        currentScore += 15;
        sessionStorage.setItem('score', currentScore.toString());

        // Text zentriert hinzufügen
        const message = 'Oh nein, du wurdest von einem der Wachmänner erwischt!\n' +
                '15 Strafsekunden werden zu deiner Spielzeit addiert!\n' +
                'Pass das nächste Mal besser auf!';

        const gameOverText = this.add.text(this.cameras.main.centerX, this.cameras.main.centerY - 40, message, {
            fontSize: '14px',
            align: 'center',
        }).setOrigin(0.5);

        // Restart-Button zentriert darunter
        const restartButton = this.add.text(this.cameras.main.centerX, this.cameras.main.centerY + 40, 'Nochmal versuchen', {
            color: '#00FF00',
            fontSize: '16px'
        }).setOrigin(0.5).setInteractive();

        restartButton.on('pointerover', () => {
            restartButton.setStyle({ color: '#FFFF00' }) // Gelb bei Hover
        })

        restartButton.on('pointerout', () => {
            restartButton.setStyle({ color: '#00FF00' }) // Ursprüngliches Grün
        })


        restartButton.on('pointerdown', this.restartLevel, this);
    }

    // Event um das Level neu zu starten
    restartLevel() {
        this.scene.stop()
        this.scene.start('equipment')
        this.scene.start(this.caller)
    }
}
